import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AppUtils } from 'src/app/helpers/app.utils';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { PageUrls } from 'src/app/helpers/page-urls';
import { TableModel } from 'src/app/models/table.model';
import { Subscription } from 'rxjs';
import { GettyOrderService } from 'src/app/admin/services/getty.order.service';
import { PagedGettyOrderDetail } from 'src/app/admin/models/paged.getty.order.detail';
import { SelectListItemModel } from 'src/app/models/select.list.item.model';
import { GettyOrderDetailFilterModel } from 'src/app/admin/models/getty.order.detail.filter.model';

@Component({
    selector: 'app-getty-order-detail',
    templateUrl: './getty.order.detail.component.html'
})
export class GettyOrderDetailComponent implements OnInit {

    totalRecords = 0;
    pagedGettyOrderDetails = new PagedGettyOrderDetail();
    subscriptions = new Array<Subscription>();
    photographers = new Array<SelectListItemModel>();
    tableModel = new TableModel();
    isModelLoaded = false;
    gettyOrderDetailFilter = new GettyOrderDetailFilterModel();

    gettyOrderId: number;
    gettyOrderFileName: string;

    get urls() {
        return PageUrls;
    }

    constructor(private router: Router,
        private spinner: NgxSpinnerService,
        private toastr: ToastrService,
        private gettyOrderService: GettyOrderService,
        private route: ActivatedRoute) {
        this.tableModel.orderBy = 'contributorName';
        this.tableModel.orderByDirection = 'asc';
    }

    ngOnInit() {
        this.gettyOrderId = this.route.snapshot.queryParams.id;
        this.gettyOrderFileName = this.route.snapshot.queryParams.name;
        this.initSubscribers();
        this.getGettyOrderDetails();
        this.loadPhotographers();
    }

    loadPhotographers() {
        this.gettyOrderService.getPhotographerNameList().subscribe(
            (response: Array<SelectListItemModel>) => {
                this.photographers = response;
            },
            error => {
                console.log(error);
            });
    }

    initSubscribers() {
        const subscription = this.tableModel.pageChanged.subscribe(() => this.getGettyOrderDetails());
        this.subscriptions.push(subscription);
    }

    getGettyOrderDetails() {
        this.spinner.show();
        this.gettyOrderService.details(this.gettyOrderDetailFilter, this.tableModel, this.gettyOrderId).subscribe(
            data => {
                Object.assign(this.pagedGettyOrderDetails, data);
                this.totalRecords = data.totalCount;
                this.pagedGettyOrderDetails.items.forEach(order => {
                    order.salesDate = AppUtils.getFormattedDate(order.salesDate);
                });

                this.spinner.hide();
                this.isModelLoaded = true;
            },
            error => {
                this.spinner.hide();
                AppUtils.processErrorResponse(this.toastr, error);
            });
    }

    openImageDetail(imageId: number) {
        let returnParams = `url=${PageUrls.Admin.GettyOrderDetail}`;
        returnParams += `&id=${this.gettyOrderId}`;
        returnParams += `&name=${this.gettyOrderFileName}`;
        this.router.navigateByUrl(
            `${PageUrls.Admin.UpdateImage}?imageId=${imageId}&${returnParams}`);
    }

    resetTableModel(): void {
        this.tableModel.page = 1;
    }
}
